import React from 'react';
import { pickBy, pick, isEmpty } from 'lodash';
import { Section, SocialLinks } from 'modules/ui';

function getSocialMediaLinks(person) {
  return pick(person, [
    'facebookLink',
    'instagramLink',
    'twitterLink',
    'linkedinLink',
    'imdbLink',
  ]);
}

export default function SocialLinksSection({ person, showTitle = true }) {
  const socialMediaLinks = getSocialMediaLinks(person);
  const populatedLinks = pickBy(socialMediaLinks);

  return (
    <Section
      title={showTitle ? 'Social Networks' : ''}
      isEmpty={isEmpty(populatedLinks)}
      PlaceholderComponent={null}
    >
      <SocialLinks links={populatedLinks} />
    </Section>
  );
}
